import React, { useContext } from 'react';

import DropdownMenuContext from './DropdownMenuContext';

/**
 * Dropdown menu item.
 *
 * @param {Object} props - Component props.
 * @returns {React$Node}
 */
export default function DropdownItem({
    children,
    className = '',
    content,
    description,
    elemBefore,
    isDisabled,
    isSelected,
    onClick,
    shouldAllowMultiline
}) {
    const { close } = useContext(DropdownMenuContext);

    const _onClick = event => {
        if (isDisabled) {
            event.preventDefault();

            return;
        }

        onClick?.(event);
        close(event);
    };

    return (
        <button
            className = { `overflow-menu-item ${isSelected ? 'selected-option' : ''} ${className}`.trim() }
            disabled = { isDisabled }
            onClick = { _onClick }
            style = {{
                alignItems: 'flex-start',
                background: 'transparent',
                border: 0,
                color: 'inherit',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                display: 'flex',
                flexDirection: 'column',
                gap: description ? '4px' : 0,
                opacity: isDisabled ? 0.6 : 1,
                padding: '10px 14px',
                textAlign: 'left',
                width: '100%'
            }}
            type = 'button'>
            <span
                style = {{ alignItems: 'center',
                    display: 'inline-flex',
                    gap: '10px',
                    width: '100%' }}>
                {elemBefore ? <span className = 'overflow-menu-item-icon'>{elemBefore}</span> : null}
                <span style = {{ whiteSpace: shouldAllowMultiline ? 'normal' : 'nowrap' }}>
                    {children || content}
                </span>
            </span>
            {description ? (
                <span
                    style = {{ color: '#6b778c',
                        fontSize: '12px',
                        lineHeight: 1.4,
                        whiteSpace: 'normal' }}>
                    {description}
                </span>
            ) : null}
        </button>
    );
}
